import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
    const { user, login } = useAuth();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (user && user.role) navigate("/admin", { replace: true });
    }, [user, navigate]);

    const onSubmit = async (e) => {
        e.preventDefault();
        const fd = new FormData(e.currentTarget);
        const email = fd.get("email")?.toString() || "";
        const password = fd.get("password")?.toString() || "";
        setLoading(true);
        const res = await login(email, password);
        setLoading(false);
        if (res.ok) {
            toast.success("Welcome back.");
            navigate("/admin");
        } else {
            toast.error(res.error || "Login failed.");
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center container-px bg-[hsl(var(--muted))]">
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7 }}
                className="w-full max-w-md bg-background border border-border p-10 sm:p-14"
                data-testid="admin-login-card"
            >
                <Link to="/" className="overline" data-testid="login-back-link">
                    ← Back to López Hill
                </Link>
                <h1 className="mt-6 font-serif text-4xl font-light tracking-tight">
                    Team portal
                </h1>
                <p className="mt-3 text-sm text-muted-foreground font-light">
                    Sign in to manage inquiries, calendar and chat logs.
                </p>

                <form onSubmit={onSubmit} className="mt-10 space-y-8" data-testid="admin-login-form">
                    <div className="flex flex-col gap-2">
                        <label className="overline">Email</label>
                        <input
                            name="email"
                            type="email"
                            required
                            className="h-12 border-b border-border bg-transparent focus:outline-none focus:border-[hsl(var(--primary))]"
                            data-testid="login-email"
                        />
                    </div>
                    <div className="flex flex-col gap-2">
                        <label className="overline">Password</label>
                        <input
                            name="password"
                            type="password"
                            required
                            className="h-12 border-b border-border bg-transparent focus:outline-none focus:border-[hsl(var(--primary))]"
                            data-testid="login-password"
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full mt-4 px-8 py-4 bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))] hover:bg-[hsl(var(--primary-hover))] transition-all duration-300 text-xs tracking-[0.3em] uppercase disabled:opacity-60"
                        data-testid="login-submit"
                    >
                        {loading ? "Signing in…" : "Sign in"}
                    </button>
                </form>
            </motion.div>
        </div>
    );
}
